// extracted by mini-css-extract-plugin
export default {"recipesSection":"Recipes_recipesSection__aqiIx","cardGrid":"Recipes_cardGrid__0eaYz"};